import Vue from 'vue'
import store from '@/store'

/**
 * Global `price` filter: converts a USD amount to the user's local
 * currency and formats it. Falls back to formatted USD until exchange
 * rates load (the template re-renders automatically when they arrive,
 * because the filter reads reactive Vuex state during render).
 *
 *   {{ 49.99 | price }}                       → 'Rs 13,893.87'
 *   {{ plan.amount | price({ round: true }) }} → 'Rs 13,894'
 *   {{ plan.amount | price({ currency: 'AED' }) }}
 */
Vue.filter('price', (usdAmount, options) => {
  const value = Number(usdAmount)
  if (!Number.isFinite(value)) return usdAmount
  return store.getters['currency/format'](value, options)
})
